var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"owl-dots molecule-content-thumb-slider-brochure",attrs:{"id":"content-slide-portfolio-custom-dots"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }